module.exports = __webpack_public_path__ + "static/ojoscerrados_icon.e40e7520.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ojoscerrados_icon.png
// module id = 434
// module chunks = 35783957827783